import { LightTheme } from './schemes/light-theme';
import { DarkTheme } from './schemes/dark-theme';

const themeMap = {
  LightTheme,
  DarkTheme,
};

export function themeCreator(theme) {
  return themeMap[theme];
}
